import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import MediaLibraryItem from "@/models/Media/Library/Item/MediaLibraryItem";

export default class Title extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/title';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetTitles';

    static model_name = 'Title';

    static fields() {
        return {
            id: this.number(null).nullable(),
            media_library_item_id: this.number(null).nullable(),
            title_nl: this.attr(null),
            title_en: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            mediaLibraryItem: this.belongsTo(MediaLibraryItem, 'media_library_item_id'),
        }
    }

    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }


}
